import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';
import LOGO from '../assets/images/logo.png';
// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  return <Box component="img" src={LOGO} sx={{ margin:"auto",width: 130, height: 55, ...sx }} />

}
